import { Row, Col } from 'react-bootstrap';
import PercentageField from '../fields/PercentageField';

const CalculatedIncomeResults = ({
  incomeMeasurementType,
  incomeMeasurementPercentage,
  arrearage,
  isSubmitting,
}) => {

  return (
    <Row>
      <Col md={6}>
        <PercentageField
          value={incomeMeasurementPercentage}
          fieldName={`${incomeMeasurementType} Percentage`}
          readonly
          disabled
          isSubmitting={isSubmitting}
        />
      </Col>
      <Col md={6}>
        <PercentageField
          value={arrearage}
          fieldName="Arrearage"
          readonly
          disabled
          isSubmitting={isSubmitting}
          />
      </Col>
    </Row>
  );
};

export default CalculatedIncomeResults;